import React from 'react';
import useBackLayer from '../hooks/useBackLayer';
import SettingsDialog from './SettingsDialog';
import PushSettings from './PushSettings';
export default function PushSettingsDialog({ username, onClose }) {
  useBackLayer(true, onClose);
  return <SettingsDialog title="Bildirimler" onClose={onClose}><PushSettings username={username} /></SettingsDialog>;
}
